import Button from "../../../core/Button";
import {
  Card,
  CardContent,
  CardTitle,
  CardHeader,
  CardDescription,
} from "../../../shadcn/Card";
import { SavedSearch } from "src/types/neighborhoodSearch";
import { useMemo } from "react";

export interface RegionSearchResultsSidebarFooterProps {
  selectedSearches: SavedSearch[];
  onLoadSearchesClick: () => void;
}

export const ListSearchesSidebarFooter = ({
  onLoadSearchesClick,
  selectedSearches,
}: RegionSearchResultsSidebarFooterProps) => {
  const title = useMemo(() => {
    if (selectedSearches.length > 1) {
      return `${selectedSearches.length} searches selected`;
    }

    if (selectedSearches.length === 1) {
      return selectedSearches?.[0]?.name;
    }

    return "No searches selected";
  }, [selectedSearches]);

  const description = useMemo(() => {
    if (selectedSearches.length) {
      const totalProperties = selectedSearches.reduce(
        (acc, search) => acc + search.result_count,
        0
      );

      return `${totalProperties} properties`;
    }
    return "No searches selected";
  }, [selectedSearches]);

  if (!selectedSearches.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 w-full items-center">
      <Card className="w-full">
      <CardHeader className="py-3">
          <CardTitle className="text-center text-primary text-xl">
            {title}
          </CardTitle>
          <CardDescription className="text-center">
            {description}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <Button
            className="w-full"
            onClick={(e) => {
              e.stopPropagation();
              onLoadSearchesClick();
            }}
          >
            Load Properties
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
